/*
*   @site           Preloaded: Site
*   @function       Module Controller
*   @author         Last17
*   @copyright      Copyright 2025, Preloaded.com
*   @version        0.01
*
*********************************************************************************************/


//-----------------------------------------------
// Imports
//-----------------------------------------------

//Modules
import ModuleHero from '../_modules/ModuleHero';
import ModuleMediaParallax from '../_modules/ModuleMediaParallax';
import ModuleCarouselMedia from '../_modules/ModuleCarouselMedia';
import ModuleCarouselSpecialism from '../_modules/ModuleCarouselSpecialism';
import ModuleItemIndex from '../_modules/ModuleItemIndex';
import ModuleCarouselLogos from '../_modules/ModuleCarouselLogos';
import ModuleLensWipe from '../_modules/ModuleLensWipe';

//Module: Templates
import ModuleCarousel from '../_templates/ModuleCarousel';
import ModuleTemplate from '../_templates/ModuleTemplate';


//Globals
import * as Globals from '../_constants/Globals';
import ItemController from './ItemController';



//-----------------------------------------------
// Class Definition
//-----------------------------------------------
class _ModuleController {

  //-----------------------------------------------
  // Constructor
  //-----------------------------------------------
  constructor() {
    //List
    this.list = [];

    //Register the classes
    this.classList = {
      'hero': {
        class: ModuleHero,
      },
      'carousel-media': {
        class: ModuleCarouselMedia,
      },
      'carousel-generic': {
        class: ModuleCarousel,
      },
      'carousel-logos': {
        class: ModuleCarouselLogos,
      },
      'carousel-specialism': {
        class: ModuleCarouselSpecialism,
      },
      'lens-wipe': {
        class: ModuleLensWipe
      },
      'media-parallax': {
        class: ModuleMediaParallax
      },
      'item-index': {
        class: ModuleItemIndex
      },
      'standard': {
        class: ModuleTemplate
      }
    };

    //Listen for resize
    PubSub.subscribe('resize', (id, data) => { this.resizeEvent(data); });
  }


  //-----------------------------------------------
  // Resize Event
  //-----------------------------------------------
  resizeEvent(data) {
    //Fire resize events within the modules
    for (let i = 0; i < this.list.length; i++) {
      this.list[i].module.resizeEvent(data);
    }

    //Global calls
    ItemController.setTitleHeights();
  }


  //-----------------------------------------------
  // Get a module by ID
  //-----------------------------------------------
  get(id) {
    for(let i = 0; i < this.list.length; i++) {
      if(this.list[i].type === 'hero') {
        return this.list[i].module;
      }
    }
    return null;
  }



  //-----------------------------------------------
  // Init
  //-----------------------------------------------
  init() {
    //Individual module setup
    let elements = document.querySelectorAll('.module:not(.grid)');
    let moduleType;
    let id = 0;
    for (let i = 0; i < elements.length; i++) {
      moduleType = 'standard';
      if (elements[i].getAttribute('data-module-js') && this.classList[elements[i].getAttribute('data-module-js')] !== undefined) {
        moduleType = elements[i].getAttribute('data-module-js');
      }

      //Add to list
      this.list.push({
        module: new this.classList[moduleType].class(elements[i], ++id),
        element: elements[i],
        type: moduleType
      });
    }
  }

  //-----------------------------------------------
  // Get the module list
  //-----------------------------------------------
  getModules() {
    return this.list;
  }

}


//--------------------------------------------------------------------------
//  Export
//--------------------------------------------------------------------------
const ModuleController = new _ModuleController();
export default ModuleController;